import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  FaUtensils,
  FaBed,
  FaStethoscope,
  FaHandHoldingHeart,
  FaRegCheckCircle,
} from "react-icons/fa";
import { RotatingLines } from "react-loader-spinner";
import { useSearchWorkers } from "../../../context/SearchWorkersContext";

const ICON_MAPPING = {
  "Daily living, social and community activities": <FaUtensils size={24} />,
  "Personal care": <FaBed size={24} />,
  Nursing: <FaStethoscope size={24} />,
  "Allied health": <FaHandHoldingHeart size={24} />,
};

const WorkerSupportTypesComponent = ({
  onUpdate,
  supportDetailsValue,
  isError,
  errorMessage,
  clearError,
}) => {
  const {
    getSelectionIdFromCookies,
    searchSelections,
    supportTypes,
    fetchSupportTypes,
  } = useSearchWorkers();
  const [selectedSupportLabels, setSelectedSupportLabels] = useState(
    supportDetailsValue || []
  );
  const [localErrorMessage, setLocalErrorMessage] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    const selectionId = getSelectionIdFromCookies();
    console.log(
      "[WorkerSupportTypesComponent] Retrieved selectionId from cookies:",
      selectionId
    );
    if (!selectionId) {
      console.warn("No selectionId found. Redirecting to /search-workers...");
      navigate("/account/fs-dashboard/search-workers");
    }
  }, [getSelectionIdFromCookies, navigate]);

  useEffect(() => {
    fetchSupportTypes().catch((error) =>
      console.error("Error fetching support types:", error)
    );
  }, [fetchSupportTypes]);

  useEffect(() => {
    setSelectedSupportLabels(searchSelections?.supportTypeDetails || []);
  }, [searchSelections]);

  useEffect(() => {
    if (selectedSupportLabels.length > 0) {
      onUpdate(selectedSupportLabels);
      setLocalErrorMessage("");
      clearError && clearError();
    } else if (isError) {
      setLocalErrorMessage(errorMessage || "Please make a selection");
    }
  }, [selectedSupportLabels, onUpdate, isError, errorMessage, clearError]);

  const toggleSupportLabel = (label) => {
    setSelectedSupportLabels((prev) => {
      if (prev.includes(label)) {
        const updated = prev.filter((type) => type !== label);
        console.log(`[toggleSupportLabel] Removing label: "${label}"`);
        console.log("[toggleSupportLabel] Updated Support Labels:", updated);
        return updated;
      } else {
        const updated = [...prev, label];
        console.log(`[toggleSupportLabel] Adding label: "${label}"`);
        console.log("[toggleSupportLabel] Updated Support Labels:", updated);
        return updated;
      }
    });
  };

  useEffect(() => {
    onUpdate(selectedSupportLabels);
  }, [selectedSupportLabels, onUpdate]);

  const getIconColor = (index) => {
    const colors = ["#3f51b5", "#c2185b", "#009688", "#00bcd4"];
    return colors[index % colors.length];
  };

  const SupportType = ({ label, description, index }) => (
    <div
      onClick={() => toggleSupportLabel(label)}
      className={`support-type ${
        selectedSupportLabels.includes(label) ? "support-type-selected" : ""
      }`}
    >
      {selectedSupportLabels.includes(label) ? (
        <div className="wstc-icon-selected">
          <FaRegCheckCircle size={34} />
        </div>
      ) : (
        <div
          className="wstc-icon"
          style={{ backgroundColor: getIconColor(index) }}
        >
          {ICON_MAPPING[label]}
        </div>
      )}
      <div className="support-type-description">
        <h3>{label}</h3>
        <p>{description}</p>
      </div>
    </div>
  );

  return (
    <div className="worker-support-types-container">
      <h2>Select worker support areas</h2>
      <div className="support-types-scrollable">
        {supportTypes.length > 0 ? (
          supportTypes.map((supportType, index) => (
            <SupportType
              key={index}
              label={supportType.label}
              description={supportType.description}
              index={index}
            />
          ))
        ) : (
          <div style={{ textAlign: "left", marginLeft: "20px" }}>
            <RotatingLines
              visible={true}
              height="76"
              width="36"
              color="grey"
              strokeWidth="3"
              animationDuration="0.75"
              ariaLabel="rotating-lines-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
          </div>
        )}
        {isError && (
          <span className="wstc-error-message">{localErrorMessage}</span>
        )}
      </div>
    </div>
  );
};

export default WorkerSupportTypesComponent;
